import { render, staticRenderFns } from "./Coupondetail.vue?vue&type=template&id=7b2f0aa2&"
import script from "./Coupondetail.vue?vue&type=script&lang=js&"
export * from "./Coupondetail.vue?vue&type=script&lang=js&"
import style0 from "./Coupondetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports